module.exports = __webpack_public_path__ + "img/regular_off.98c4a943.svg";